import { render, staticRenderFns } from "./ResortFilterItem.vue?vue&type=template&id=456ef4ba&"
import script from "./ResortFilterItem.vue?vue&type=script&lang=ts&"
export * from "./ResortFilterItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports